module.exports = __webpack_public_path__ + "img/6.8a14533c.jpg";